import { render, staticRenderFns } from "./AGCRadioGroup.vue?vue&type=template&id=3a878d60&"
import script from "./AGCRadioGroup.vue?vue&type=script&lang=js&"
export * from "./AGCRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports